module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('nav', {
    staticClass: "c-pagination c-pagination--bordered"
  }, [_c('a', {
    staticClass: "c-pagination__item button",
    class: {
      'is-disabled': _vm.actualPage === 1
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.change(1)
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('a', {
      key: page,
      staticClass: "c-pagination__item",
      class: {
        'is-active': _vm.actualPage == page
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.change(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    staticClass: "c-pagination__item",
    class: {
      'is-disabled': _vm.actualPage === _vm.pagesAmount
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.change(_vm.pagesAmount)
      }
    }
  }, [_vm._v("»")])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-399b3b84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Paginator.vue
// module id = 3061
// module chunks = 0